// extracted by mini-css-extract-plugin
export var chevronIcon = "_7o-2";
export var teamName = "_7o-1";
export var teamSwitcherButton = "_7o-0";